/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../config';
import API from '../../../network';

const useClients = (props?: { enabled?: boolean }) => {
  const { enabled } = props || { enabled: true };
  const {
    isLoading, data, error, refetch,
  } = useQuery({
    queryKey: QueryKeys.CLIENTS,
    queryFn: async () => API.getInstance().getClients().then((response) => response.data),
    refetchOnWindowFocus: false,
    initialData: [],
    enabled,
  });

  const clientOptions = React.useMemo(
    () => data?.map((option) => ({ label: option.name, value: option.id })) || [],
    [data],
  );

  return {
    clientsLoading: isLoading,
    clientOptions,
    data,
    error,
    fetchClients: refetch,
  };
};

export {
  useClients,
};
